
import Description from '../../components/Description/Description';
import EmailField from '../../components/EmailField/EmailField';
import Group from '../../components/Group/Group';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import PhoneField from '../../components/PhoneField/PhoneField';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import { scrollToFieldWithError } from '../../helpers/scrollToFieldWithError';
import { useAppDispatch } from '../../hooks';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import usePagesConfig from '../../hooks/usePagesConfig';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';
import useValidation from '../../hooks/useValidation';
import { addOrUpdateFormField } from '../../store/applicationform';
import { WizardPageAction } from '../../store/wizard/wizard';

const ContactDetailsPage = () => {
    useComponentTracker('ContactDetailsPage');

    const dispatch = useAppDispatch();
    const translate = useTranslation();
    const defaultPagesAction = useDefaultPagesAction();
    const { totalSections, totalAboutYouPages } = usePagesConfig();
    const { currentPage } = usePagesContext();
    const validationErrors = useValidation(['applicantEmailAddress', 'applicantMobileNumber']);

    useSetBannerType('bannerOne');

    const onAction = async (action: WizardPageAction) => {
        if (validationErrors.length) {
            scrollToFieldWithError(validationErrors);
            validationErrors.forEach((validationError) => {
                dispatch(addOrUpdateFormField(validationError));
            });
            return false;
        }

        return defaultPagesAction(action);
    };

    return (
        <>
            <PagesHeader
                actions={['back']}
                onAction={defaultPagesAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
            <Title text={translate('page.contact-details.title')} />
            <Description text={translate('page.contact-details.description')} />
            <Group>
                <EmailField name={'applicantEmailAddress'} label={translate('field.applicant-email-address.label')} />
                <PhoneField name={'applicantMobileNumber'} label={translate('field.applicant-mobile-number.label')} />
            </Group>
            <PagesFooter
                actions={['next']}
                onAction={onAction}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
        </>
    );
};

export default ContactDetailsPage;
